import React, { useEffect, useState } from "react";
import { VisitasUbicacionEdit } from "../../Jhimbo_visitas/VisitasEdit/VisitasUbicacionEdit";
import { VisitasSeguridadEdit } from "../../Jhimbo_visitas/VisitasEdit/VisitasSeguridadEdit";
import { VisitasPilaresEdit } from "../../Jhimbo_visitas/VisitasEdit/VisitasPilaresEdit";
import { VisitasEnvioEdit } from "../../Jhimbo_visitas/VisitasEdit/VisitasEnvioEdit";
import { VisitasMisionEdit } from "../../Jhimbo_visitas/VisitasEdit/VisitasMisionEdit";
import { VisitasHistoriaEdit } from "../../Jhimbo_visitas/VisitasEdit/VisitasHistoriaEdit";
import { ApiService } from "../../ApiService";

export const CompanyUbication = ({
	currentBranch,
}) => {
	const apiUrl = process.env.REACT_APP_API_URL;
	const [companyDetails, setCompanyDetails] = useState({});
	useEffect(() => {
		const fetchCompanyData = async () => {
			const url = `api/company/us?key_branch=${currentBranch}`;
			const response = await ApiService.fetchData(url, { method: "GET" });
			if (response) {
				setCompanyDetails(response);
			}
		};
		fetchCompanyData();
	}, [currentBranch]);
	return (
		<div>
			<VisitasHistoriaEdit
				companyData={{ view3: companyDetails.view3, view4: companyDetails.view4 }}
				currentBranch={currentBranch}
			/>
			<VisitasUbicacionEdit view3={companyDetails.view3} />
			<VisitasSeguridadEdit companyData={companyDetails} currentBranch={currentBranch} />
			<VisitasPilaresEdit companyData={companyDetails} currentBranch={currentBranch} />
			<VisitasEnvioEdit companyData={companyDetails} currentBranch={currentBranch} />
			<VisitasMisionEdit currentBranch={currentBranch} companyData={companyDetails?.view_mission} />
		</div>
	);
};
